import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { fieldTypeName } from '@/constants/fields';
import DictionaryFieldType from './DictionaryFieldType';
import DictionaryFieldTypeLookup from './DictionaryFieldTypeLookup';
import DictionaryFieldTypeDropdown from '../components/DictionaryFieldTypeDropdown';
import DictionaryFieldContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/DictionaryFieldContainer';

const DictionaryFieldTypeTableCell = ({
  code,
  category,
  type,
  constraint,
  lookups,
  hasLookup,
  dictionaryUUID,
  fieldUUID,
  isEditing,
  exists,
  canRead,
  canEdit,
  updateType,
  pmnFunctions,
  template,
}) => {
  const intl = useIntl();
  const updateFieldType = (newType, newConstraint = null) => (
    updateType(category, code, dictionaryUUID, newType, newConstraint, fieldUUID, pmnFunctions, template)
  );

  const updateFieldConstraint = (newConstraint) => updateFieldType(lookups[newConstraint].type, newConstraint);

  if (!isEditing) {
    return (
      <>
        {hasLookup && (
          <DictionaryFieldTypeLookup
            category={category}
            code={code}
            canRead={canRead}
            canEdit={canEdit}
            constraint={constraint}
          />
        )}
        <DictionaryFieldType
          category={category}
          code={code}
          canRead={canRead}
          canEdit={canEdit && !hasLookup}
          colSpan={hasLookup ? null : 2}
          value={intl.formatMessage({ id: fieldTypeName(type) })}
        />
      </>
    );
  }

  return (
    <DictionaryFieldContainer
      exists={exists}
      canRead={canRead}
      canEdit={canEdit}
      colSpan={2}
    >
      <DictionaryFieldTypeDropdown
        type={type}
        constraint={constraint}
        lookups={lookups}
        onTypeChange={updateFieldType}
        onConstraintChange={updateFieldConstraint}
      />
    </DictionaryFieldContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldTypeTableCell);
